import { render, staticRenderFns } from "./ManageRate.vue?vue&type=template&id=23b6e05c"
import script from "./ManageRate.vue?vue&type=script&lang=ts"
export * from "./ManageRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports